<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (tpaRequestDetailModel) {
    <div class="request-screen-system" menuSystem [cerrixTab]="tab">
        <div
            class="request-screens"
            [attr.name]="'externalConnections.detail.assuranceRequestSubmenuName' | transloco"
            menuicon="fas fa-calculator"
            menusystemsubmenu
        >
            <div [attr.name]="'externalConnections.detail.detailsMenuItemName' | transloco" menuItemId="menuItemDetails" menuicon="fas fa-info-circle" menusystemitem>
                <div class="detail-page-card">
                    <div class="detail-page-card-title"></div>
                </div>
                @if (tpaRequestDetailModel.ID > 0) {
                    <div class="detail-page-summary">
                        <div class="row">
                            <div class="col-6">
                                <div class="property">
                                    <b>{{ 'externalConnections.detail.requestIdLabel' | transloco }}</b> {{ tpaRequestDetailModel.requestID }}
                                </div>
                                <div class="property">
                                    <b>{{ 'externalConnections.detail.connectionNameLabel' | transloco }}</b> &nbsp;<span
                                        data-uiid="request-detail-name-label"
                                        >{{ tpaRequestDetailModel.connectionName }}</span
                                    >
                                </div>
                                <div class="property">
                                    <b>{{ 'externalConnections.detail.requestedTestTypeLabel' | transloco }}</b>
                                    {{ tpaRequestDetailModel.requestedTestplanType }}
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="property">
                                    <b>{{ 'externalConnections.detail.startDateLabel' | transloco }}</b>
                                    {{ tpaRequestDetailModel.startDate | dateFormat }}
                                </div>
                                <div class="property">
                                    <b>{{ 'externalConnections.detail.endDateLabel' | transloco }}</b>
                                    {{ tpaRequestDetailModel.endDate | dateFormat }}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (validConfig) {
                    <generic-list-manager [config]="validConfig"></generic-list-manager>
                }
                @if (invalidConfig) {
                    <generic-list-manager [config]="invalidConfig"></generic-list-manager>
                }
            </div>
        </div>
    </div>
}
